import React from 'react';
import SectionHeading from '../components/SectionHeading';
import CTAButton from '../components/CTAButton';
import { CheckCircle } from 'lucide-react';
const AboutPage = () => {
  return <div className="w-full" data-id="element-622">
      {/* Hero Section */}
      <section className="bg-navy text-white py-16" data-id="element-623">
        <div className="container-custom text-center" data-id="element-624">
          <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-6" data-id="element-625">
            About Operation Launchpad
          </h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-626">
            Building a bridge from aspiration to entrepreneurial success in any
            industry.
          </p>
        </div>
      </section>
      {/* Our Story Section */}
      <section className="section-padding" data-id="element-627">
        <div className="container-custom" data-id="element-628">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-629">
            <div data-id="element-630">
              <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Juan Olmedo, CEO of Operation Launchpad" className="rounded-lg shadow-lg w-full h-auto" data-id="element-631" />
            </div>
            <div data-id="element-632">
              <h2 className="text-3xl font-bold text-navy mb-6 font-montserrat" data-id="element-633">
                Meet Juan Olmedo
              </h2>
              <h3 className="text-xl text-darkGray mb-4 font-montserrat" data-id="element-634">
                CEO & Executive Director
              </h3>
              <p className="mb-4" data-id="element-635">
                With over 25 years in business development and 17 years
                mentoring aspiring entrepreneurs, Juan Olmedo founded Operation
                Launchpad with a clear mission: to help determined individuals
                build successful businesses without the decade-long learning
                curve he experienced.
              </p>
              <p className="mb-4" data-id="element-636">
                After building his own multi-million dollar company, Juan
                recognized that many aspiring entrepreneurs possess the
                discipline, leadership, and work ethic needed for business
                success, but lack the specific knowledge, systems, and support
                to overcome common obstacles.
              </p>
              <p data-id="element-637">
                Through Operation Launchpad, Juan and his team provide the
                blueprint, tools, and mentorship that can help committed
                entrepreneurs reach $1M+ in annual revenue in a fraction of the
                time it would take on their own.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Mission Section */}
      <section className="section-padding bg-lightGray" data-id="element-638">
        <div className="container-custom" data-id="element-639">
          <SectionHeading title="Our Mission" subtitle="Operation Launchpad is a nonprofit incubator foundation with a singular focus: removing barriers to success for entrepreneurs in any industry." data-id="element-640" />
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12" data-id="element-641">
            <p className="text-lg mb-8" data-id="element-642">
              We believe that with the right support system, business framework,
              and mentorship, hard-working individuals can build thriving
              businesses that provide financial independence and create a
              lasting legacy.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-643">
              <div data-id="element-644">
                <h3 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-645">
                  What We Provide
                </h3>
                <ul className="space-y-3" data-id="element-646">
                  {['Marketing systems that generate qualified leads', 'Sales processes that convert prospects to clients', 'Leadership development for effective team building', 'Technology implementation for operational efficiency', 'Financial management for sustainable growth', 'Compliance guidance to navigate regulations'].map((item, index) => <li key={index} className="flex items-start" data-id="element-647">
                      <CheckCircle className="text-gold mr-2 flex-shrink-0 mt-1" size={20} data-id="element-648" />
                      <span data-id="element-649">{item}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-650">
                <h3 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-651">
                  Our Approach
                </h3>
                <p className="mb-4" data-id="element-652">
                  Unlike traditional business programs, Operation Launchpad
                  offers our solutions at discounted or no upfront cost.
                  Instead, we take a vested interest in your success through
                  future billing once your business is generating revenue.
                </p>
                <p className="mb-4" data-id="element-653">
                  This model ensures that we're truly invested in your growth
                  and success - we only win when you win.
                </p>
                <p data-id="element-654">
                  Our focus is on teaching you how to build your dreams into
                  reality without spending 10+ years learning through trial and
                  error.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="section-padding" data-id="element-655">
        <div className="container-custom" data-id="element-656">
          <SectionHeading title="Our Core Values" subtitle="These principles guide everything we do at Operation Launchpad." data-id="element-657" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-658">
            <ValueCard title="Perseverance" description="We believe in pushing through challenges and never giving up on your business goals, no matter the obstacles." icon="💪" data-id="element-659" />
            <ValueCard title="Integrity" description="We operate with honesty and transparency in all our dealings, building trust with our entrepreneurs and partners." icon="⭐" data-id="element-660" />
            <ValueCard title="Community" description="We foster a supportive network of entrepreneurs who share knowledge, resources, and encouragement." icon="🤝" data-id="element-661" />
            <ValueCard title="Excellence" description="We strive for the highest standards in our programs, mentorship, and the businesses we help build." icon="🏆" data-id="element-662" />
            <ValueCard title="Innovation" description="We continuously improve our methods and embrace new technologies to give our entrepreneurs a competitive edge." icon="💡" data-id="element-663" />
            <ValueCard title="Service" description="We dedicate ourselves to the success of our entrepreneurs in their business endeavors." icon="🎖️" data-id="element-664" />
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-navy text-white py-16" data-id="element-665">
        <div className="container-custom text-center" data-id="element-666">
          <h2 className="text-3xl md:text-4xl font-bold font-montserrat mb-6" data-id="element-667">
            Join Our Mission
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto" data-id="element-668">
            Ready to transform your business idea into a thriving reality? Apply
            today to see if Operation Launchpad is the right fit for your
            entrepreneurial journey.
          </p>
          <CTAButton text="Apply Now" to="/apply" className="text-lg" data-id="element-669" />
        </div>
      </section>
    </div>;
};
const ValueCard = ({
  title,
  description,
  icon
}) => {
  return <div className="bg-white rounded-lg shadow-md p-6 transition duration-300 hover:shadow-lg border-t-4 border-gold" data-id="element-670">
      <div className="text-4xl mb-4" data-id="element-671">{icon}</div>
      <h3 className="text-xl font-bold text-navy mb-3 font-montserrat" data-id="element-672">
        {title}
      </h3>
      <p className="text-darkGray" data-id="element-673">{description}</p>
    </div>;
};
export default AboutPage;